import React from "react";

const Attention = () => {
    return (
        <span style={{color: "red", fontWeight: "700"}}>*</span>
    )
}

export default Attention;